var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9987 12.6667C3.9987 13.4 4.5987 14 5.33203 14H10.6654C11.3987 14 11.9987 13.4 11.9987 12.6667V6C11.9987 5.26667 11.3987 4.66667 10.6654 4.66667H5.33203C4.5987 4.66667 3.9987 5.26667 3.9987 6V12.6667ZM11.9987 2.66667H10.332L9.8587 2.19333C9.7387 2.07333 9.56536 2 9.39203 2H6.60536C6.43203 2 6.2587 2.07333 6.1387 2.19333L5.66536 2.66667H3.9987C3.63203 2.66667 3.33203 2.96667 3.33203 3.33333C3.33203 3.7 3.63203 4 3.9987 4H11.9987C12.3654 4 12.6654 3.7 12.6654 3.33333C12.6654 2.96667 12.3654 2.66667 11.9987 2.66667Z",
    fill: "#282860"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9dab00adb54f22b68368647b228ab190.svg";
export { ForwardRef as ReactComponent };